import Vue from "vue";
import Router from "vue-router";
//import { i18n } from "./main.js";
//import RouterView from "./components/RouterView.vue";
import Home from '@/components/Home.vue';
import Aboutus from '@/components/Aboutus.vue';
import Successes from '@/components/Successes.vue';
import Contactperson from '@/components/Contactperson.vue';
import FAQ from '@/components/FAQ.vue';
import Links from '@/components/Links.vue';
import Downloads from '@/components/Downloads.vue';
import Sponsors from '@/components/Sponsors.vue';
import Trainingtimes from '@/components/Trainingtimes.vue';
import Traininglocations from '@/components/Traininglocations.vue';
import Dues from '@/components/Dues.vue';
import Demonstrations from '@/components/Demonstrations.vue';
import Tournaments from '@/components/Tournaments.vue';
import Courses from '@/components/Courses.vue';
import Exams from '@/components/Exams.vue';
import Youthtravel from '@/components/Youthtravel.vue';
import Festivities from '@/components/Festivities.vue';
import Trips from '@/components/Trips.vue';
import Various from '@/components/Various.vue';
import Poomsaevideos from '@/components/Poomsaevideos.vue';
import Breaktest from '@/components/Breaktest.vue';
import Shows from '@/components/Shows.vue';
import Beltties from '@/components/Beltties.vue';
import Newspaper from '@/components/Newspaper.vue';
import TV from '@/components/TV.vue';
import Radio from '@/components/Radio.vue';
import Terms from '@/components/Terms.vue';
import Numbers from '@/components/Numbers.vue';
import History from '@/components/History.vue';
import Southkorea from '@/components/Southkorea.vue';
import Regulations from '@/components/Regulations.vue';
import Clothing from '@/components/Clothing.vue';
import Meaning from '@/components/Meaning.vue';
import Poomsae from '@/components/Poomsae.vue';
import Legalnotice from '@/components/Legalnotice.vue';
import Privacy from '@/components/Privacy.vue';
import Disclaimer from '@/components/Disclaimer.vue';
import Trainingplan from '@/components/Trainingplan.vue';

Vue.use(Router);

export default new Router({
    mode: "history",
    linkExactActiveClass: '',
    linkActiveClass: '',
    base: process.env.BASE_URL,
    component: {
        Home, Aboutus, Contactperson, Successes, FAQ, Links, Downloads, Sponsors,
        Trainingtimes, Traininglocations, Dues,
        Demonstrations, Tournaments, Courses, Exams, Youthtravel, Festivities, Trips, Various,
        Poomsaevideos, Breaktest, Shows, Beltties,
        Newspaper, TV, Radio,
        Terms, Numbers, History, Southkorea, Regulations, Clothing, Meaning, Poomsae,
        Legalnotice, Privacy, Disclaimer, Trainingplan
    },
    routes: [
        {
            path: '/',
            redirect: '/de/Home'
        },
        {
            path: '/de',
            redirect: '/de/Home'
        },
        {
            path: '/en',
            redirect: '/en/Home'
        },
             {
            path: '/:lang(de,en)?',
            component: {
                render: h=> h('router-view')
            },
            children: [
                {
                    path: '/:lang/Home',
                    name: 'Home',
                    component: Home
                },
                {
                    path: '/:lang/Aboutus',
                    name: 'Aboutus',
                    component: Aboutus
                },
                {
                    path: '/:lang/Successes',
                    name: 'Successes',
                    component: Successes
                },
                {
                    path: '/:lang/Contactperson',
                    name: 'Contactperson',
                    component: Contactperson
                },
                {
                    path: '/:lang/FAQ',
                    name: 'FAQ',
                    component: FAQ
                },
                {
                    path: '/:lang/Links',
                    name: 'Links',
                    component: Links
                },
                {
                    path: '/:lang/Downloads',
                    name: 'Downloads',
                    component: Downloads
                },
                {
                    path: '/:lang/Sponsors',
                    name: 'Sponsors',
                    component: Sponsors
                },
                {
                    path: '/:lang/Trainingtimes',
                    name: 'Trainingtimes',
                    component: Trainingtimes
                },
                {
                    path: '/:lang/Traininglocations',
                    name: 'Traininglocations',
                    component: Traininglocations
                },
                {
                    path: '/:lang/Dues',
                    name: 'Dues',
                    component: Dues
                },
                {
                    path: '/:lang/Demonstrations',
                    name: 'Demonstrations',
                    component: Demonstrations
                },
                {
                    path: '/:lang/Tournaments',
                    name: 'Tournaments',
                    component: Tournaments
                },
                {
                    path: '/:lang/Courses',
                    name: 'Courses',
                    component: Courses
                },
                {
                    path: '/:lang/Exams',
                    name: 'Exams',
                    component: Exams
                },
                {
                    path: '/:lang/youthtravel',
                    name: 'Youthtravel',
                    component: Youthtravel
                },
                {
                    path: '/:lang/Festivities',
                    name: 'Festivities',
                    component: Festivities
                },
                {
                    path: '/:lang/Trips',
                    name: 'Trips',
                    component: Trips
                },
                {
                    path: '/:lang/Various',
                    name: 'Various',
                    component: Various
                },
                {
                    path: '/:lang/Poomsaevideos',
                    name: 'Poomsaevideos',
                    component: Poomsaevideos
                },
                {
                    path: '/:lang/Breaktest',
                    name: 'Breaktest',
                    component: Breaktest
                },
                {
                    path: '/:lang/Shows',
                    name: 'Shows',
                    component: Shows
                },
                {
                    path: '/:lang/Beltties',
                    name: 'Beltties',
                    component: Beltties
                },
                {
                    path: '/:lang/Newspaper',
                    name: 'Newspaper',
                    component: Newspaper
                },
                {
                    path: '/:lang/TV',
                    name: 'TV',
                    component: TV
                },
                {
                    path: '/:lang/Radio',
                    name: 'Radio',
                    component: Radio
                },
                {
                    path: '/:lang/Terms',
                    name: 'Terms',
                    component: Terms
                },
                {
                    path: '/:lang/Numbers',
                    name: 'Numbers',
                    component: Numbers
                },
                {
                    path: '/:lang/History',
                    name: 'History',
                    component: History
                },
                {
                    path: '/:lang/Southkorea',
                    name: 'Southkorea',
                    component: Southkorea
                },
                {
                    path: '/:lang/Regulations',
                    name: 'Regulations',
                    component: Regulations
                },
                {
                    path: '/:lang/Clothing',
                    name: 'Clothing',
                    component: Clothing
                },
                {
                    path: '/:lang/Meaning',
                    name: 'Meaning',
                    component: Meaning
                },
                {
                    path: '/:lang/Poomsae',
                    name: 'Poomsae',
                    component: Poomsae
                },
                {
                    path: '/:lang/Legalnotice',
                    name: 'Legalnotice',
                    component: Legalnotice
                },
                {
                    path: '/:lang/Privacy',
                    name: 'Privacy',
                    component: Privacy
                },
                {
                    path: '/:lang/Disclaimer',
                    name: 'Disclaimer',
                    component: Disclaimer
                },
                {
                    path: '/:lang/Trainingplan',
                    name: 'Trainingplan',
                    component: Trainingplan
                }
            ]
        }
    ]
});